import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=02bc338c&scoped=true&"
import script from "./ProductInfo.vue?vue&type=script&lang=ts&"
export * from "./ProductInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=02bc338c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc338c",
  null
  
)

export default component.exports